import { trackEvent } from 'lib/ui-analytics';

import { BRAND_RCI } from 'contexts/CruiseSearchContext/constants';
import { getItineraryCardInfo } from 'lib/ui-analytics/utils';
import {
  TRACKING_ACTION,
  TRACKING_FAVORITES_CEL,
  TRACKING_INTERACTION,
} from '../Constants';
import { getInteraction } from '../utils';

const {
  FAVORITES_AND_WATCHLIST: {
    CLICK_REMOVED,
    CLICK_FAVORITE_BUTTON,
    CLICK_FAVORITE_BUTTON_INTERACTION,
    CLICK_WATCHLIST_BUTTON,
  } = {},
} = TRACKING_INTERACTION;

export const utagFavoritesWatchlistCardClicked = (
  clickedButton,
  interaction,
  extraParams,
) => {
  const {
    masterSailing,
    lowestPriceSailing,
    id,
    vdsId,
    productViewLink,
    searchIndex,
    resultsLength,
    locale,
    brand = BRAND_RCI.code,
    startDate = '',
    endDate = '',
    component = 'search',
  } = extraParams;

  const productEvent = getProductEvent(clickedButton, interaction);

  let interactionEvent = {};

  if (brand === BRAND_RCI.code) {
    const action = getUserAction(clickedButton, interaction) || productEvent;

    interactionEvent = {
      country: locale.country,
      currency: locale.currency,
      language: locale.language,
      eventType: TRACKING_ACTION.INTERACTION,
      interaction: getInteraction(searchIndex, resultsLength, masterSailing, action),
      itineraryCardInfo: getItineraryCardInfo(id, masterSailing, lowestPriceSailing),
      csDepartureDate: [lowestPriceSailing?.startDate],
      cardPosition: [searchIndex],
      groupId: [id],
      prodCategory: ['Booking'],
      prodCost: [
        Math.round(lowestPriceSailing?.lowestStateroomClassPrice?.price?.value),
      ],
      prodSku: [masterSailing?.itinerary?.code],
      productEvent: [productEvent],
    };
  } else {
    let productEvent =
      clickedButton === CLICK_FAVORITE_BUTTON
        ? interaction === CLICK_REMOVED
          ? TRACKING_FAVORITES_CEL.FAVORITES_REMOVED
          : TRACKING_FAVORITES_CEL.FAVORITES_ADDED
        : interaction === CLICK_REMOVED
        ? TRACKING_FAVORITES_CEL.WATCHLIST_REMOVED
        : TRACKING_FAVORITES_CEL.WATCHLIST_ADDED;
    productEvent = productEvent.replace('{0}', component);
    interactionEvent = {
      eventType: TRACKING_ACTION.INTERACTION,
      interaction: `cruise search : ${searchIndex} of ${resultsLength} : ${masterSailing?.itinerary?.totalNights} night ${masterSailing?.itinerary?.name}: ${productEvent}`,
      Booking_Product_Detail: 'Standard Cruise | Position 1',
      bookingDesc: `${masterSailing?.itinerary?.totalNights} night ${masterSailing?.itinerary?.name} From ${startDate} - ${endDate}`,
      cruise_duration: masterSailing?.itinerary?.totalNights,
      deembarkation_date: endDate,
      embarkation_port: masterSailing?.itinerary?.departurePort?.code,
      link_name: productViewLink,
      page_name: TRACKING_FAVORITES_CEL.ITINERARY_PAGE,
      product_name: masterSailing?.itinerary?.name,
      product_id: `Booking-${id}`,
      product_event: [productEvent.replace(/:/g, '')],
      shipName: masterSailing?.itinerary?.ship?.name,
      ship_code: masterSailing?.itinerary?.ship?.code,
      prodCategory: ['booking'],
      product_sku: [`Booking-${masterSailing?.itinerary?.code}`],
      prodQuantity: [1],
      prodCost: [
        Math.round(lowestPriceSailing?.lowestStateroomClassPrice?.price?.value),
      ],
      site_section: TRACKING_FAVORITES_CEL.ITINERARY_PAGE,
      starting_from_price: Math.round(
        lowestPriceSailing?.lowestStateroomClassPrice?.price?.value,
      ),
      VDSID: vdsId,
    };
  }
  trackEvent(interactionEvent);
};

export const getProductEvent = (clickedButton, interaction) => {
  return `${clickedButton}${
    clickedButton === CLICK_WATCHLIST_BUTTON || interaction === CLICK_REMOVED
      ? `${interaction}`
      : ''
  }`;
};

export const getUserAction = (clickedButton, interaction) => {
  let action = null;
  if (clickedButton === CLICK_FAVORITE_BUTTON) {
    action = `${CLICK_FAVORITE_BUTTON_INTERACTION}${interaction}`;
  }
  return action;
};
